module.exports = __webpack_public_path__ + "img/calendar.d926cbd5.svg";